import { render } from "./Dimension.vue?vue&type=template&id=3c58b4c6&scoped=true"
import script from "./Dimension.vue?vue&type=script&lang=js"
export * from "./Dimension.vue?vue&type=script&lang=js"

import "./Dimension.vue?vue&type=style&index=0&id=3c58b4c6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c58b4c6"]])

export default __exports__